import { Component, AfterViewInit, OnDestroy, ViewChild, NgZone } from '@angular/core';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { CaseDetails, PartnerInfo } from '../shared-html-components/details/details.component'
import { SharedDataService, CaseOverViewFilterOptions } from '../shared/services/shared-data.service';
import { AgGridAngular } from 'ag-grid-angular';
import { TranslateService } from '@ngx-translate/core';
import { SmallActivity } from '../documents/document.contract';
import { CustomerDetails, AddressDetails } from '../shared-html-components/details/models';
import * as api from '../shared/api/apihandler';

@Component({
  selector: 'app-cases',
  templateUrl: './cases.component.html',
  styleUrls: ['./cases.component.css'],
})

export class CasesComponent implements OnDestroy, AfterViewInit {
  // Subscriptions
  private companyInformationSubscription: Subscription;
  private filterSubscription: Subscription;
  private responsibleSubscription: Subscription;

  @ViewChild('caseGrid') grid: AgGridAngular;
  filters = new CaseOverViewFilterOptions();

  defaultGridState: Array<any> = [
    { "colId": "notifications", "width": 75, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "unreadMessage", "width": 75, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "unreadPartnerMessage", "width": 75, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "channel", "width": 55, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "caseType", "width": 57, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "origin", "width": 57, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "status", "width": 102, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "caseNumber", "width": 74, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "propertiesProperty", "width": 100, "hide": true, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "propertiesPropertyName", "width": 100, "hide": true, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "propertiesLease", "width": 100, "hide": true, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "title", "width": 211, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "description", "width": 162, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "partner", "width": 100, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "createdAt", "width": 122, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "lastModified", "width": 129, "hide": true, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "customerName", "width": 138, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "customerAddress", "width": 127, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "customerZipCode", "width": 108, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "customerCity", "width": 111, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "deliveryName", "width": 158, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "deliveryAddress", "width": 177, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "deliveryZipCode", "width": 133, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "deliveryCity", "width": 118, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "requisitionNumber", "width": 100, "hide": true, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "reference", "width": 143, "hide": true, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "responsible", "width": 100, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "fitter", "width": 100, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "planned", "width": 126, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "doneBy", "width": 100, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "activityDate", "width": 127, "hide": false, "sort": null, "sortIndex": null, "flex": null },
    { "colId": "activityText", "width": 173, "hide": false, "sort": null, "sortIndex": null, "flex": null }
  ];
  sidebar = {
    toolPanels: [
      {
        id: 'columns', toolPanel: 'agColumnsToolPanel', labelKey: 'columns', labelDefault: 'Columns', toolPanelParams: {
          suppressRowGroups: true,
          suppressValues: true,
          suppressPivots: true,
          suppressPivotMode: true,
          suppressSideButtons: true,
          suppressColumnFilter: true,
          suppressColumnSelectAll: true,
          suppressColumnExpandAll: true,
        }
      },
      { id: 'filters', toolPanel: 'agFiltersToolPanel', labelKey: 'filters', iconKey: 'filter', labelDefault: 'Filters' }
    ],
    defaultToolPanel: ''
  }

  statusBar = {
    statusPanels: [
      {
        statusPanel: 'customStatusBarComponent',
        align: 'left'
      },
      {
      statusPanel: 'customPaginationComponent',
      align: 'right'
      }
  ],
} 
  companyInfo; // for company specific filtration in get cases

  propertyOwner = false;
  propertyManagement = false;
  reverse = true;
  cases: Array<CaseOverviewCase>;
  viewAmount = 60;
  startAmount = 0;
  endAmount = 100;
  statusData: Array<Status>;
  caseCreationRight = false;
  showCase = '';
  partnerCaseId;
  partnerCases: CaseDetails;
  partnerCasesList: Array<CaseDetails> = [];
  partnerInfo: PartnerInfo;
  frameworkComponents;

  responsibles: any = [];

  dateOptions = {
    'month': 'short', 'day': '2-digit', 'hour': '2-digit', 'minute': '2-digit', 'hour12': false, 'weekday': 'short'
  }
  transferImages = [];
  transferringFiles = false;

  statuses: any = {};
  //AG Grid
  tableColumns = [];
  defaultColumns = {
    width: 100,
    sortable: true,
    floatingFilter: true,
    suppressMenu: true,
    floatingFilterComponentParams: { suppressFilterButton: false },
    filter: 'agTextColumnFilter',
    filterParams: { newRowsAction: 'keep'},
    resizable: true,
    menuTabs: [],
    minWidth: 100
  }
  tableSetUpDone = false;
  getMoreCases = true;
  gridTranslates;

  currentCase = new NewCase();
  customerComponentMessage;
  previousStep;
  customerComponentData;
  filterSaveName: string = '';
  filterDeleteName: any;

  isNotMobile = true;
  constructor(
    private httpClient: HttpClient,
    private router: Router,
    private sharedData: SharedDataService,
    private translate: TranslateService,
    private zone: NgZone
  ) {
    
    //this.frameworkComponents = {
    //  customStatusBarComponent: CustomStatusBarComponent,
    //  customPaginationComponent: CustomPaginationComponent
    //}
  }

  ngOnInit() {
    this.isNotMobile = !this.isMobile();
    this.gridTranslates = this.translate
    //this.statusTranslator();
    this.companyInformationSubscription = this.sharedData.companyInformation().subscribe(data => {
      this.companyInfo = data;
      if (!!data) {  }
    })
    this.filterSubscription = this.sharedData.filterUpdate().subscribe((data) => {
      if (data == null) { this.sharedData.needUpdate(); }
      else {
        this.filters = data.caseOverView;
        if (data.caseOverView.gridState != null && data.caseOverView.gridState != undefined ) {
          //console.log("gridstate2", data.caseOverView)
          if (data.caseOverView.gridState.length == this.defaultGridState.length) { this.defaultGridState = data.caseOverView.gridState }
          else {
            for (let x of data.caseOverView.gridState) {
              let a = this.defaultGridState.find(y => y.colId == x.colId);
              if (a != null) { a = x }
            }
          }
        }
        
        //this.autoDeactivateColumns();
        if (this.isNotMobile) {
          this.setupTable();
        }
        else {
          this.getCasesNew(true, new Object);
        }
      }
    });
    this.responsibleSubscription = this.sharedData.responsibles().subscribe((data) => { this.responsibles = data })
  }

  caseCellRenderer(params) {
    let response: string;
    switch (params.value) {
      case ('8850aee1-48a3-48a6-aa98-2e1597b7b1d7'): {
        response = 'Åben'
          ; break
      }
      case ('6991f0ea-bdb5-4e30-868f-46c43d712e9b'): {
        response = 'Planlæg'
          ; break
      }
      case ('99bc09b6-b7f7-46c0-a40b-5dfc27ec9cf0'): {
        response = 'Aflyst'
          ; break
      }
      case ('7bccdf15-ad49-4cc9-b358-68e08287f32f'): {
        response = 'Bogført'
          ; break
      }
      case ('a693c47f-9685-4bb6-bf6e-bcab86cb88de'): {
        response = 'Lukket'
        break
      }
      case ('(Vælg alle)'): {
        response = '(Vælg alle)'
        break
      }
      default:
        response = ''
        break;
    }
    return response;
  }

  CommunicationCellRenderer(params) {
    let response: string;
    switch (params.value) {
      case ('true'): {
        response = 'Aktiv'
          ; break
      }
      case ('false'): {
        response = 'Ikke aktiv'
          ; break
      }
      case ('(Vælg alle)'): {
        response = '(Vælg alle)'
        break;
      }
      default:
        response = ''
        break;
    }
    return response;
  }

  MessageCellRenderer(params) {
    let response: string;
    switch (params.value) {
      case ('true'): {
        response = 'Vis'
          ; break
      }
      case ('false'): {
        response = 'Vis ikke'
          ; break
      }
      case ('(Vælg alle)'): {
        response = '(Vælg alle)'
        break;
      }
      default:
        response = ''
        break;
    }
    return response;
  }

  caseTypeCellRenderer(params) {
    let response: string;
    switch (params.value) {
      case ('bd48b31e-4801-495a-8a18-0b7a9ed41683'): {
        response = 'Pakke'
          ; break
      }
      case ('64746e1d-06c6-4534-8a93-5c60c7c12efb'): {
        response = 'Rekvisition'
          ; break
      }
      case ('fe09d5ec-b73a-4c2c-b01e-7305a6abeb56'): {
        response = 'Service'
          ; break
      }
      case ('2702bac1-23b6-4dad-8bc6-7ce980ba435a'): {
        response = 'Tilbud'
          ; break
      }
      case ('022c6519-14e1-40a7-9133-801e4d47a332'): {
        response = 'Ekstern sag'
        break
      }
      case ('1dc53948-194c-4ec0-8905-ed11e3bbdca2'): {
        response = 'Sag'
        break
      }
      case ('(Vælg alle)'): {
        response = '(Vælg alle)'
        break
      }
      default:
        response = ''
        break;
    }
    return response;
  }

  getResponsible() {
    let response: string[] = new Array();
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Website/CompanyUserCanBe/Responsible', { headers }).subscribe(
      (data: any) => {
        data.forEach(function (item) {
          response.push(item.value)
        })
      });
    return response;
  }

  getfitters() {
    let response: string[] = new Array();
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Website/CompanyUserCanBe/Fitter', { headers }).subscribe(
      (data: any) => {
        data.forEach(function (item) {
          response.push(item.value)
        })
      });
    return response;
  }

  getCaseStatusList() {
    let status = ["6991f0ea-bdb5-4e30-868f-46c43d712e9b", "8850aee1-48a3-48a6-aa98-2e1597b7b1d7", "99bc09b6-b7f7-46c0-a40b-5dfc27ec9cf0", "7bccdf15-ad49-4cc9-b358-68e08287f32f", "a693c47f-9685-4bb6-bf6e-bcab86cb88de"];
    let response: object[] = new Array();
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Shared/CaseStatus', { headers }).subscribe(
      (data: any) => {
        data.forEach(function (item) {
          if (status.includes(item.caseStatusId)) {
            response.push(item.caseStatusId)
          }
        })
      });
    return response;
  }

  getCaseTypes() {
    let response: string[] = new Array();
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Website/Case/GetCaseTypes', { headers }).subscribe(
      (data: any) => {
        data.forEach(function (item) {
          response.push(item.id)
        })
      });
    return response;
  }

  getCaseChannels() {
    let response: string[] = new Array();
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Website/Case/GetCaseChannels', { headers }).subscribe(
      (data: any) => {
        data.forEach(function (item) {
          response.push(item.name)
        })
      });
    return response;
  }

  getCaseOrigins() {
    let response: string[] = new Array();
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Website/Case/GetCaseOrigins', { headers }).subscribe(
      (data: any) => {
        data.forEach(function (item) {
          response.push(item)
        })
      });
    return response;
  }

  ngAfterViewInit() {
    document.addEventListener('keydown', (e) => this.flipGridPages(e))
  }

  ngOnDestroy() {
    this.filterSubscription.unsubscribe();
    this.companyInformationSubscription.unsubscribe();
    this.responsibleSubscription.unsubscribe();
    this.saveFilters();
    document.removeEventListener('keydown', (e) => this.flipGridPages(e))
  }

  async setupTable() {
    //let phone = document.documentElement.clientWidth < 500 ? true : false;
    let cols: Array<Object> = [];
    for (let x of this.defaultGridState) {
      let a = await this.getColumnDefsById(x)
      if (a != null) { await cols.push(a) }
    }
    this.tableColumns = await cols;
    this.getCasesNew(true, new Object);
  }

  async getColumnDefsById(data) {
    let hasPropertyRights = JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'PropertyManagement') != null ? true : false;
    let standard = {
      colId: data.colId,
      width: data.width,
      sort: data.sort,
      sortIndex: data.sortIndex,
      hide: data.hide,
    }
    switch (data.colId) {
      case ('notifications'): {
        let translate = await this.translate.instant('Standard.Communication');
        let specifik = {
          headerName: translate,
          field: 'disableNotification',
          cellRenderer: this.notificationCheck,
          filter: 'agSetColumnFilter',
          filterParams: {
            values: ['true', 'false'],
            cellRenderer: this.CommunicationCellRenderer,
          }
        }
        return { ...standard, ...specifik }
      }
      case ('unreadMessage'): {
        let translate = await this.translate.instant('Standard.UnreadMessages');
        let specifik = {
          headerName: translate,
          field: 'unreadMessage',
          cellRenderer: this.unreadMessageCheck,
          filter: 'agSetColumnFilter',
          filterParams: {
            values: ['true', 'false'],
            cellRenderer: this.CommunicationCellRenderer,
          }
        }
        return { ...standard, ...specifik }
      }
      case ('unreadPartnerMessage'): {
        let translate = await this.translate.instant('Standard.UnreadPartnerMessages');
        let specifik = {
          headerName: translate,
          field: 'unreadPartnerMessage',
          cellRenderer: this.unreadPartnerMessageCheck,
          filter: 'agSetColumnFilter',
          filterParams: {
            values: ['true', 'false'],
            cellRenderer: this.CommunicationCellRenderer,
          }
        }
        return { ...standard, ...specifik }
      }
      case ('origin'): {
        let translate = await this.translate.instant('Standard.Origin');
        let specifik = {
          headerName: translate,
          field: 'origin.name',
          filter: 'agSetColumnFilter',
          filterParams: {
            values: await this.getCaseOrigins(),
          }
        }
        return { ...standard, ...specifik }
      }
      case ('caseType'): {
        let translate = await this.translate.instant('Standard.CaseType');
        let specifik = {
          headerName: translate,
          field: 'caseType.id',
          cellRenderer: this.caseTypeCellRenderer,
          filter: 'agSetColumnFilter',
          filterParams: {
            values: await this.getCaseTypes(),
            cellRenderer: this.caseTypeCellRenderer,
          }
        }
        return { ...standard, ...specifik }
      }
      case ('channel'): {
        let translate = await this.translate.instant('Word.Channel');
        let specifik = {
          headerName: translate,
          field: 'caseChannel.Name',
          filter: 'agSetColumnFilter',
          filterParams: {
            values: await this.getCaseChannels(),
          }
        }
        return { ...standard, ...specifik }
      }
      case ('status'): {
        let translate = await this.translate.instant('Standard.Status');
        let specifik = {
          headerName: translate,
          field: 'status',
          cellRenderer: this.caseCellRenderer,
          filter: 'agSetColumnFilter',
          filterParams: {
            values: this.getCaseStatusList(),
            cellRenderer: this.caseCellRenderer
          },
        }

        return { ...standard, ...specifik }
      }
      case ('caseNumber'): {
        let translate = await this.translate.instant('Standard.CaseNumber');
        let specifik = {
          headerName: translate,
          field: data.colId,
          minWidth: 50,
          comparator: this.numbSort
        }
        return { ...standard, ...specifik }
      }
      case ('partner'): {
        let translate = await this.translate.instant('Standard.Partner');
        let specifik = {
          headerName: translate,
          field: 'partner',
          floatingFilter: false,
          cellRenderer: this.caseHasPartnerConnection,
          cellStyle: { 'text-align': 'center' },
          minWidth: 0
        }
        return { ...standard, ...specifik }
      }
      case ('propertiesProperty'): {
        let translate = await this.translate.instant('Properties.Property');
        let specifik = {
          headerName: translate,
          field: 'property.number',
          filter: 'agSetColumnFilter', floatingFilterComponentParams: {
            suppressFilterButton: false
          },
          //cellRenderer: this.propertyValueFormatter,
          cellClass: (params) => { let specifik = params.value == null ? 'text-center' : '' }
        }
        return { ...standard, ...specifik }
      }
      case ('propertiesPropertyName'): {
        let translate = await this.translate.instant('Properties.PropertyName');
        let specifik = {
          headerName: translate,
          field: 'property.name',
          filter: 'agSetColumnFilter', floatingFilterComponentParams: {
            suppressFilterButton: false
          },
          //cellRenderer: this.propertyValueFormatter,
          cellClass: (params) => { let specifik = params.value == null ? 'text-center' : '' }
        }
        return { ...standard, ...specifik }
      }
      case ('propertiesLease'): {
        let translate = await this.translate.instant('Properties.Lease');
        let specifik = {
          headerName: translate,
          field: 'lease',
          filter: 'agSetColumnFilter', floatingFilterComponentParams: {
            suppressFilterButton: false
          },
          cellRenderer: this.leaseValueFormatter,
          cellClass: (params) => { let specifik = params.value == null ? 'text-center' : '' }
        }
        return { ...standard, ...specifik }
      }
      case ('createdAt'): {
        let translate = await this.translate.instant('Standard.CreatedAt');
        let specifik = {
          headerName: translate,
          field: data.colId,
          filter: 'agDateColumnFilter',
          cellRenderer: this.dateFormatter
        }
        return { ...standard, ...specifik }
      }
      case ('lastModified'): {
        let translate = await this.translate.instant('Standard.LastModified');
        let specifik = {
          headerName: translate,
          cellRenderer: this.dateFormatter,
          field: data.colId,
          filter: 'agDateColumnFilter'
        }
        return { ...standard, ...specifik }
      }
      case ('customerName'): {
        let translate = await this.translate.instant('Standard.CustomerName');
        let specifik = {
          headerName: translate,
          field: 'customer.name'
        }
        return { ...standard, ...specifik }
      }
      case ('customerAddress'): {
        let translate = await this.translate.instant('Standard.CustomerAddress');
        let specifik = {
          headerName: translate,
          field: 'customer.address'
        }
        return { ...standard, ...specifik }
      }
      case ('customerZipCode'): {
        let translate = await this.translate.instant('Standard.CustomerZipCode');
        let specifik = {
          headerName: translate,
          field: 'customer.zipCode'
        }
        return { ...standard, ...specifik }
      }
      case ('customerCity'): {
        let translate = await this.translate.instant('Standard.CustomerCity');
        let specifik = {
          headerName: translate,
          field: 'customer.city',
        }
        return { ...standard, ...specifik }
      }
      case ('deliveryName'): {
        let translate = await this.translate.instant('Standard.DeliveryName');
        let specifik = {
          headerName: translate,
          field: 'deliveryAddress.name'
        }
        return { ...standard, ...specifik }
      }
      case ('deliveryAddress'): {
        let translate = await this.translate.instant('Standard.DeliveryAddress');
        let specifik = {
          headerName: translate,
          field: 'deliveryAddress.address'
        }
        return { ...standard, ...specifik }
      }
      case ('deliveryZipCode'): {
        let translate = await this.translate.instant('Standard.DeliveryZipCode');
        let specifik = {
          headerName: translate,
          field: 'deliveryAddress.zipCode'
        }
        return { ...standard, ...specifik }
      }
      case ('deliveryCity'): {
        let translate = await this.translate.instant('Standard.DeliveryCity');
        let specifik = {
          headerName: translate,
          field: 'deliveryAddress.city'
        }
        return { ...standard, ...specifik }
      }
      case ('title'): {
        let translate = await this.translate.instant('Standard.Title');
        let specifik = {
          headerName: translate,
          field: data.colId
        }
        return { ...standard, ...specifik }
      }
      case ('description'): {
        let translate = await this.translate.instant('Standard.Description');
        let specifik = {
          headerName: translate,
          field: data.colId
        }
        return { ...standard, ...specifik }
      }
      case ('responsible'): {
        let translate = await this.translate.instant('Standard.Responsible');
        let specifik = {
          headerName: translate,
          field: 'responsible',
          filter: 'agSetColumnFilter',
          filterParams: {
            values: await this.getResponsible()
          },
          refreshValuesOnOpen: true,
        }
        return { ...standard, ...specifik }
      }
      case ('fitter'): {
        let translate = await this.translate.instant('Standard.Fitter');
        let specifik = {
          headerName: translate,
          field: 'fitter',
          filter: 'agSetColumnFilter',
          filterParams: {
            values: await this.getfitters()
          },
          refreshValuesOnOpen: true,
        }
        return { ...standard, ...specifik }
      }
      case ('requisitionNumber'): {
        let translate = await this.translate.instant('Standard.RequisitionNumber');
        let specifik = {
          headerName: translate,
          field: data.colId
        }
        return { ...standard, ...specifik }
      }
      case ('reference'): {
        let translate = await this.translate.instant('Offer.OurReference')
        let specifik = {
          headerName: translate,
          field: 'ourReference'
        }
        return { ...standard, ...specifik }
      }
      case ('planned'): {
        let translate = await this.translate.instant('Standard.Planned');
        let specifik = {
          headerName: translate,
          valueGetter: (params) => {
            return params.data.startTime != null ? new Date(params.data.startTime + 'Z') : null
          },
          field: 'startTime',
          filter: 'agDateColumnFilter',
          cellRenderer: this.dateFormatter
        }
        return { ...standard, ...specifik }
      }
      case ('doneBy'): {
        let translate = await this.translate.instant('Standard.DoneBy');
        let specifik = {
          headerName: translate,
          field: data.colId,
          filter: 'agSetColumnFilter', floatingFilterComponentParams: {
            suppressFilterButton: false
          }
        }
        return { ...standard, ...specifik }
      }
      case ('activityDate'): {
        let translate = await this.translate.instant('Activity.Date');
        let specifik = {
          headerName: translate,
          field: 'activities',
          filter: 'agDateColumnFilter',
          cellRenderer: this.activityDateFormatter
        }
        return { ...standard, ...specifik }
      }
      case ('activityText'): {
        let translate = await this.translate.instant('Activity.Text');
        let specifik = {
          headerName: translate,
          field: 'activities',
          cellRenderer: this.activityTextFormatter
        }
        return { ...standard, ...specifik }
      }
      default: {
        return null
      }
    }
  }

  isMobile() {
    return (typeof window.orientation !== "undefined") || (navigator.userAgent.indexOf('IEMobile') !== -1);
  }

  fakeMobile(event) {
    console.log(event)
    if (event.ctrlKey && event.altKey) {
      this.isNotMobile = !this.isNotMobile
    }
  }

  getStatusTranslate(id) {
    switch (id) {
      case ('8850aee1-48a3-48a6-aa98-2e1597b7b1d7'): {
        return 'CaseStatus.Name.Open'
      }
      case ('6991f0ea-bdb5-4e30-868f-46c43d712e9b'): {
        return 'CaseStatus.Name.NeedPlanning'
      }
      case ('99bc09b6-b7f7-46c0-a40b-5dfc27ec9cf0'): {
        return 'CaseStatus.Name.Canceled'
      }
      case ('7bccdf15-ad49-4cc9-b358-68e08287f32f'): {
        return 'CaseStatus.Name.Posted'
      }
      case ('a693c47f-9685-4bb6-bf6e-bcab86cb88de'): {
        return 'CaseStatus.Name.Closed'
      }
      default:
        return ''
    }
  }

  async autoDeactivateColumns() {
    this.defaultGridState.find(y => y.colId == 'activityDate').hide = await JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'Activities') != null ? false : true;
    this.defaultGridState.find(y => y.colId == 'activityText').hide = await JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'Activities') != null ? false : true;
    this.defaultGridState.find(y => y.colId == 'propertiesProperty').hide = await JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'PropertyManagement') != null ? false : true;
    this.defaultGridState.find(y => y.colId == 'propertiesLease').hide = await JSON.parse(localStorage.getItem('guards')).find(x => x.name == 'PropertyManagement') != null ? false : true;
    this.setupTable();
  }
  // GRID CELL RENDERERS

  notificationCheck(params) {
    return params.data.disableNotification == true ? '<i class="fas fa-bell icons text-primary">' : '<i class="fas fa-bell-slash icons text-danger">';
  }

  unreadMessageCheck(params) {
    return params.data.unreadMessage == true ? '<span style="margin-left:1.5rem;"><i class="fas fa-envelope icons new-message text-danger"></i></span>' : null;
  }

  unreadPartnerMessageCheck(params) {
    return params.data.unreadPartnerMessage == true ? '<span style="margin-left:1.5rem;"><i class="fas fa-envelope icons new-message text-primary"></i></span>' : null;
  }

  dateFormatter(params) {
    // should use FLD timeFormat
    let pipe = new DatePipe('da-DK');
    return params.value != null && params.value != undefined ? pipe.transform(new Date(params.value), 'dd-MM-yy HH:mm') : '';
  }

  activityDateFormatter(params) {
    if (params.data.activities == null || params.data.activities.length == 0) {return ''}
    let status = '';
    let date = new Date(params.data.activities[0].date);
    if (new Date() > date) { status = 'text-danger' }
    let pipe = new DatePipe('da-DK');
    return '<span class="' + status + '"><i class="far fa-calendar-alt" style="margin-right:.2rem"> </i>' + pipe.transform(date, 'dd-MM-yy') + '</span > <span style="margin:0 .2rem" class="' + status + '" > <i class="far fa-clock" > </i>' + pipe.transform(date, 'HH:mm') + '</span >';
  }

  activityTextFormatter(params) {
    if (params.data.activities == null || params.data.activities.length == 0) { return '' }
    return params.data.activities[0].description
  }

  caseHasPartnerConnection(params) {
    return params.data.partner != null && params.data.partner.length > 0 ? '<span class="w-100 text-center text-primary cursor-pointer"><i class="fas fa-handshake mr-1"></i></span>' : '';
  }

  casePerformedBy(params) {
    return params.value.length > 0 ? params.value[0].name : ''
  }

  channelIcon(params) {
    let text = params.value != null ? params.value : ''
    return '<i class="' + params.data.caseChannel.icon + '"></i><span class="ml-2">' + text + '</span>'
  }

  propertyValueFormatter(params) {
    return params.value != null ? params.value.number + ' ' + params.value.name : '<i class="far fa-exclamation-circle text-danger"></i>';
  }

  leaseValueFormatter(params) {
    return params.value != null ? params.value.number + ' ' + params.value.address : '<i class="far fa-exclamation-circle text-danger"></i>';
  }

  messageChecker(a, b, nodeA, nodeB, invert) {
    return nodeA.data.unreadMessage === nodeB.data.unreadMessage ? 0 : nodeA.data.unreadMessage ? -1 : 1;
  }

  numbSort(a, b) {
    if (a == null || b == null) {
      if (a == null && b == null) { return 0 }
      if (a == null && b != null) { return -1 }
      if (a != null && b == null) { return 1 }
    }
    if (a.includes('-') || b.includes('-')) {
      if (a.includes('-') && b.includes('-')) {
        if (a.split('-')[0] == b.split('-')[0]) {
          return +(a.split('-')[1]) > +(b.split('-')[1]) ? 1 : -1;
        }
        else { return +(a.split('-')[0]) > +(b.split('-')[0]) ? 1 : -1; }
      }
      if (a.includes('-') && !b.includes('-')) {
        return +(a.split('-')[0]) > +b ? 1 : -1;
      }
      if (!a.includes('-') && b.includes('-')) {
        return +a > +(b.split('-')[0]) ? 1 : -1;
      }
    }
    return +a > +b ? 1 : -1;
  }

  activityDateComparator(a, b, nodeA, nodeB, invert) {
    if (a == null || b == null) { return a == null && b == null ? 0 : a != null ? 1 : -1 }
    return new Date(a[0].date) > new Date(b[0].date) ? -1 : 1
  }

  getStatusClassByStatusId(id) {
    switch (id) {
      case ('8850aee1-48a3-48a6-aa98-2e1597b7b1d7'):
      case ('71c47a4a-f277-42c5-8d88-b17db5a4f78f'): { return 'boxTop-success' }
      case ('6991f0ea-bdb5-4e30-868f-46c43d712e9b'): { return 'boxTop-primary' }
      case ('99bc09b6-b7f7-46c0-a40b-5dfc27ec9cf0'): { return 'boxTop-danger' }
      case ('7bccdf15-ad49-4cc9-b358-68e08287f32f'): { return 'boxTop-secondary' }
      case ('a693c47f-9685-4bb6-bf6e-bcab86cb88de'): { return 'boxTop-info' }
    }
  }

  //GRID EVENTS
  async gridEvent(event) {
    //console.log('event happened', event)
    if (this.tableSetUpDone) {
      switch (event.type) {
        case ('displayedColumnsChanged'): {
          this.filters.gridState = this.grid.columnApi.getColumnState();
          break;
        }
        case ('paginationChanged'): {
          //console.log("paginationChanged")
          if (this.grid.api.paginationGetTotalPages() == this.grid.api.paginationGetCurrentPage() + 1 && this.startAmount != 0) {
            let filters = this.grid.api.getFilterModel();
            this.getCasesNew(false, filters);
          }
          break;
        }
        case ('filterChanged') :
          {
            let filters = this.grid.api.getFilterModel();
            this.startAmount = 0;
            this.endAmount = 100;
            this.getCasesNew(false, filters);
            this.filters.gridFilters = filters;
            break;
          }
        case ('sortChanged'):
          {
            let filters = this.grid.api.getFilterModel();
            this.startAmount = 0;
            this.endAmount = 100;
            this.getCasesNew(false, filters);
            this.filters.gridFilters = filters;
            break;
          }

        case ('dragStopped'): {
          let state = await this.grid.columnApi.getColumnState();
          let filter = await this.grid.api.getFilterModel();
          this.filters.gridState = state;
          this.filters.gridFilters = filter;
          break;
        }
        case ('firstDataRendered'): {
          //if (this.filters.gridFilters != null && this.filters.gridFilters != {}) { this.grid.api.setFilterModel(this.filters.gridFilters); }
          ; break
        }
        default: { console.log('default'); break; }

      } // end switch
    }
  }

  gridCellClicked(event) {
    switch (event.column.colId) {
      case ('partner'): {
        if (event.data.partner != null) {
          this.zone.run(() => {
            this.router.navigate(['/Details/' + event.data.caseId], { queryParams: { mode: 'partner' } });
          })
        }        
        else {
          this.router.navigate(['/Details/' + event.data.caseId]);
        }
        break;
      }
      case ('unreadPartnerMessage'): {
        if (event.data.unreadPartnerMessage == true) {
          this.zone.run(() => {
            this.router.navigate(['/Details/' + event.data.caseId], { queryParams: { mode: 'partner' } });
          })
        }
        else {
          this.zone.run(() => {
            this.router.navigate(['/Details/' + event.data.caseId]);
          })
        }
        
        break
      }
      default: {
        this.zone.run(() => {
          this.router.navigate(['/Details/' + event.data.caseId]);
        })
      }
    }
  }
  
  hideUnhide(x, event) {
    this.grid.columnApi.setColumnVisible(x.colId, event.target.checked)
  }

  saveFilters() {
    this.sharedData.caseOverViewFilters = this.filters;
  }

  flipGridPages(event) {
    if ([37, 39].includes(event.keyCode)) {
      switch (event.keyCode) {
        case (37): {
          // left arrow on keyboard
          if (this.grid.api.paginationGetCurrentPage() != 0) {
            this.grid.api.paginationGoToPage(this.grid.api.paginationGetCurrentPage() - 1);
          }
          ; break
        }
        case (39): {
          // right arrow on keyboard
          if (this.grid.api.paginationGetCurrentPage() + 1 != this.grid.api.paginationGetTotalPages()) {
            this.grid.api.paginationGoToPage(this.grid.api.paginationGetCurrentPage() + 1)
          }
          ; break
        }
      }
    }
  }

  async getCasesNew(test, body: object) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.post(api.jubloApi + 'api/Website/Case/CaseOverViewPagination/' + this.startAmount + '/' + this.endAmount + '/CreatedAt/' + true,
      body
      , { headers }).subscribe(
        (data: Array<CaseOverviewCase>) => {
          this.replaceCaseData(data);
          console.log(data)
          if (this.startAmount == 0) {
            this.cases = data;
          }
          else {
            if (data.length > 0) {
              let a = this.cases.concat(data);
              this.cases = a;
            }
          }
          this.startAmount = this.startAmount + this.endAmount;
          this.endAmount = this.endAmount + this.endAmount;

          if (test) {
            if (this.filters.gridFilters != null && this.isNotMobile) {
              setTimeout(() => {
                if (this.filters.gridFilters != null) { this.grid.api.setFilterModel(this.filters.gridFilters); }
                this.tableSetUpDone = true;
              }, 1000)
            }
            else { this.tableSetUpDone = true; }
          }
        },
        () => { },
        () => {
          if (!!this.companyInfo && this.companyInfo.companyNumber == '4') { // VVSPlus - only show cases that starts with 80 or 85.
            this.cases = this.cases.filter(x => x.caseNumber == null
              || (x.caseNumber != null && x.caseNumber.startsWith('80'))
              || (x.caseNumber != null && x.caseNumber.startsWith('85')));
          } else if (!!this.companyInfo && this.companyInfo.companyNumber == '32205') { // FLD - only show cases that starts with 20.
            this.cases = this.cases.filter(x => x.caseNumber == null
              || (x.caseNumber != null && x.caseNumber.startsWith('20')));
          }
        })
  }

  replaceCaseData(data) {
    for (let x of data) {
      x.doneBy = x.doneBy != null && x.doneBy != '' && x.doneBy.length > 0 ? x.doneBy[0].name : '';
      if (x.startTime != null && this.companyInfo.vat == '12147376') {
        let min = new Date(x.startTime).getMinutes()
        x.startTime = new Date(x.startTime).getFullYear() == 1 ? null : min != 0 && min != 30 ? null : new Date(x.startTime).getMilliseconds() > 0 ? null : x.startTime
      }
    }
  }

  removeFilters() {
    if (this.isNotMobile) { this.grid.api.setFilterModel(null); }
    else {
      this.startAmount = 0;
      this.endAmount = 200;
      this.getCasesNew(null, new Object)
    }
    // should remove filters and then update the grid
  }

  showPartnerCases(partnerId, caseId) {
    this.partnerCaseId = caseId;
    this.partnerCasesList = [];
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    for (let x of partnerId) {
      this.httpClient.get(api.jubloApi + 'api/Website/Case/CaseDetails/' + x.caseId, { headers }).subscribe((data: CaseDetails) => {
        this.partnerCasesList.push(data);
        //console.log(this.partnerCasesList);
      },
        () => {

        },
        () => {
          this.partnerCases = this.partnerCasesList[0];
          this.getPartnerInfo(this.partnerCases.companyName);
          //console.log(this.partnerCases);
        }
      )
    }
    
  }

  getPartnerInfo(name) {
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.get(api.jubloApi + 'api/Partner/PartnerCaseInfo/' + this.partnerCaseId, { headers }).subscribe(
      (data: Array<PartnerInfo>) => {
        //console.log(data);
        this.partnerInfo = data.find(x => x.companyName == name);
      },
      (response) => { console.log('Error!', response) },
      () => {

      }
    )
  }

  isHTML(str) {
    var a = document.createElement('div');
    a.innerHTML = str;
    for (var c = a.childNodes, i = c.length; i--;) {
      if (c[i].nodeType == 1) { return true };
    }
    return false;
  }

  addImageToTransfer(event, id) {
    if (this.transferImages.includes(id)) {
      let a = this.transferImages.indexOf(id, 0)
      if (a > -1) { this.transferImages.splice(a, 1) }
    }
    else { this.transferImages.push(id)}
  }

  getFilesFromPartner() {
    this.transferringFiles = true;
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.post(api.jubloApi + 'api/Website/Case/CopyPartnerCaseFiles/' + this.partnerCaseId, this.transferImages, { headers }).subscribe(
      (data) => { },
      (response) => { console.log('Error!!', response) },
      () => { this.transferImages = []; this.transferringFiles = false; }
    )
  }

  getPreviousFromCurrent() {
    switch (this.currentCase.step) {
      case ('chooseLease'):
      case ('final'): {
        this.previousStep = 'chooseCustomer';
        break
      }
      case ('chooseDelivery'):
      case ('chooseContact'): {
        this.previousStep = 'final';
        break
      }
    }
  }

  pageTurner(event) {
    this.currentCase.step = event.currentStep;
    this.previousStep = event.previousStep;
  }

  createCaseChooseCustomer(id) {
    this.currentCase.customerId = id;
    if (id == null) {
      this.currentCase.step = 'newCustomer';
      this.previousStep = 'chooseCustomer'
    }
  }

  newCaseCustomerChanged(event) {
    console.log(event)
    this.customerComponentData = event;
    if (event.leases != null && event.leases.length > 0) {
      if (event.leases.length == 1) {
        this.currentCase.propertyLeaseId = event.leases[0].propertyLeaseId
      }
    }
  }

  createCase() {
    //console.log('Creating case', this.currentCase)
    let newId;
    let c = this.customerComponentData.customer;
    let d = this.customerComponentData.delivery;
    console.log(d)
    let contact = this.customerComponentData.contact;
    const headers = new HttpHeaders({ 'Authorization': localStorage.getItem('bearer') });
    this.httpClient.post(api.jubloApi + 'api/Website/Case/CreateCompanyCase', 
      {
        title: this.currentCase.title,
        description: this.currentCase.description,
        caseStatusId: '8850aee1-48a3-48a6-aa98-2e1597b7b1d7',
        disableNotification: !this.currentCase.disableNotification,
        responsibleId: null,
        requisitionNumber: this.currentCase.requisitionNumber,
        vorRef: this.currentCase.vorRef,
        customerId: c.customerId,
        deliveryAddressId: d != null ? d.deliveryId : null,
        contactAddressId: contact != null ? contact.id : null,
        propertyId: null,
        propertyLeaseId: this.currentCase.propertyLeaseId,
        caseNumber: null
      }
      , { headers }).subscribe(
        (data) => {
          this.router.navigate(['/Details/' + data]);
        },
        (response) => { },
        () => { this.currentCase = new NewCase() }
      )
  }

  getCurrentFilters() {
    console.log(Object.keys(this.grid.api.getFilterModel()))
  }

  setFilter(x) {
    if (this.isNotMobile) {
      this.grid.api.setFilterModel(x.filter)
      if (x.sort != null) {
        this.grid.columnApi.applyColumnState(
          {
            state: x.sort,
            defaultState: { sort: null }
          }
        )
      }
    }
    else {
      console.log(x)
      this.startAmount = 0;
      this.endAmount = 200;
      this.getCasesNew(null, x.filter)
    }
  }

  savePersonalFilter() {
    let filter = this.grid.api.getFilterModel();
    let sort = this.grid.columnApi.getColumnState().filter(x => x.sort != null).map(x => { return { 'colId': x.colId, 'sort': x.sort, 'sortIndex': x.sortIndex } })
    this.filters.savedFilters.push({ name: this.filterSaveName, filter: filter, sort: sort });
    this.saveFilters();
    this.filterSaveName = '';
  }

  deletePersonalFilter(filter) {
    this.filters.savedFilters = this.filters.savedFilters.filter(x => x.name != filter.name);
    this.filterDeleteName = null;
    this.saveFilters();
  }

}

export class CaseOverviewCase {
  public activities: Array<SmallActivity>;
  public caseId: string;
  public caseNumber: string;
  public caseType: CaseType;
  public companyName: string;
  public createdAt: string;
  public lastModified: string;
  public customer: CustomerDetails;
  public deliveryAddress: AddressDetails;
  public description: string;
  public disableNotifications: string;
  public disableNotification: boolean;
  public externalId: string;
  public fitter: Fitter;
  public lastMessage: LastMessage;
  public offerId: string;
  public origin: Origin;
  public propertyInfo: PropertyInfo;
  public responsible: Responsible;
  public startTime: string;
  public status: Status;
  public title: string;
  public tempCaseNumber: number;
  public parsedDescription: string;
  public unreadMessage: boolean;
  public unreadPartnerMessage: boolean;
  public requisitionNumber: string;
}

export class Customer {
  public address: string;
  public customerId: string;
  public email: string;
  public phone: string;
  public name: string;
  public city: string;
  public zipCode: string;
}

export class Fitter {
  public fitterId: string;
  public name: string;
}

export class Origin {
  public originId: string;
  public url: string;
}

export class Responsible {
  public responsibleId: string;
  public name: string;
}

export class Status {
  amount: number;
  caseStatusId: string;
  name: string;
}

export class PropertyInfo {
  propertyLeaseNumber: string;
  propertyNumber: string;
}

export class LastMessage {
  public caseId: string = '';
  public isRead: string = '';
  public sentAt: string = '';
  public sentByCustomer: boolean;
}

export class CaseType {
  public id: string;
  public name: string;
}

export class ToolTipper {
  x: string = '0px';
  y: string = '0px';
  replace(e: MouseEvent) {
    this.x = (e.clientX - 30).toString() + 'px';
    this.y = (e.clientY - 35).toString() + 'px';
  }
}

export class NewCase {
  step: string = 'chooseCustomer';
  title: string = '';
  description: string = '';
  caseStatusId: string = '8850aee1-48a3-48a6-aa98-2e1597b7b1d7';
  responsibleId: string = null;
  customerId: string;
  deliveryAddressId: string;
  contactAddressId: string = '';
  requisitionNumber: string = '';
  disableNotification: boolean = true;
  caseNumber: string = '';
  vorRef: string = '';
  propertyLeaseId: string | null;
  propertyId: string | null
  message: string;
}
